import styles from "./style.module.scss";
import {h} from "preact";

class Icons {
  renderCaretDownIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"/>
        </svg>
      </span>
    );
  }

  renderCaretUpIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"/>
        </svg>
      </span>
    );
  }

  renderChevronUpIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
        </svg>
      </span>
    );
  }

  renderChevronDownIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"/>
        </svg>
      </span>
    );
  }

  renderHeartIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"/>
        </svg>
      </span>
    );
  }

  renderInfoIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path d="M320 112C434.9 112 528 205.1 528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112zM320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM280 400C266.7 400 256 410.7 256 424C256 437.3 266.7 448 280 448L360 448C373.3 448 384 437.3 384 424C384 410.7 373.3 400 360 400L352 400L352 312C352 298.7 341.3 288 328 288L280 288C266.7 288 256 298.7 256 312C256 325.3 266.7 336 280 336L304 336L304 400L280 400zM320 256C337.7 256 352 241.7 352 224C352 206.3 337.7 192 320 192C302.3 192 288 206.3 288 224C288 241.7 302.3 256 320 256z"/>
        </svg>
      </span>
    );
  }

  renderOutlineHeartIcon() {
    return (
      <span aria-hidden="true" className={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2L443 275.5c23.6-22 37-52.8 37-85.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 36-13.1 70.6-36.6 97.5c-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5z"/>
        </svg>
      </span>
    )
  }

  renderPlusIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>
        </svg>
      </span>
    );
  }

  renderMinusIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>
        </svg>
      </span>
    );
  }

  renderCheckIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
        </svg>
      </span>
    );
  }

  renderTrashIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path d="M232.7 69.9C237.1 56.8 249.3 48 263.1 48L377 48C390.8 48 403 56.8 407.4 69.9L416 96L512 96C529.7 96 544 110.3 544 128C544 145.7 529.7 160 512 160L128 160C110.3 160 96 145.7 96 128C96 110.3 110.3 96 128 96L224 96L232.7 69.9zM128 208L512 208L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 208zM216 272C202.7 272 192 282.7 192 296L192 488C192 501.3 202.7 512 216 512C229.3 512 240 501.3 240 488L240 296C240 282.7 229.3 272 216 272zM320 272C306.7 272 296 282.7 296 296L296 488C296 501.3 306.7 512 320 512C333.3 512 344 501.3 344 488L344 296C344 282.7 333.3 272 320 272zM424 272C410.7 272 400 282.7 400 296L400 488C400 501.3 410.7 512 424 512C437.3 512 448 501.3 448 488L448 296C448 282.7 437.3 272 424 272z"/>
        </svg>
      </span>
    );
  }

  renderCrossedOutWheeledBinIcon() {
    return (
      <span aria-hidden="true" className={`${styles.icon} ${styles.solid} ${styles.crossedOutWheeledBin}`}>
        <svg
          version="1.1" id="svg1" width="793.70667" height="1122.52" viewBox="208 292.23 416 584.46" xmlns="http://www.w3.org/2000/svg">
          <g id="layer-MC0">
            <path
              id="path1"
              d="M 178.599,276.566 H 413.806 V 219.172 H 178.599 Z"
              style="fill:#050607;fill-opacity:1;fill-rule:nonzero;stroke:none"
              transform="matrix(1.3333333,0,0,-1.3333333,0,1122.52)"/>
            <path
              id="path2"
              d="m 0,0 -1.358,-15.138 h 12.113 l 0,15.138 z m -5.241,27.23 c -3.715,5.588 -9.19,9.203 -15.46,11.451 -5.776,2.071 -12.275,3.001 -18.761,3.244 V 35.837 H -77.791 V 42.86 C -85.28,42.482 -92.627,41.29 -99.923,39.653 V 27.23 Z m -0.398,-7.417 h -115.235 l 15.445,-182.602 h 65.257 c -0.247,1.364 -0.377,2.769 -0.377,4.204 0,12.108 9.203,22.073 20.995,23.274 l 10.235,114.105 h -0.807 V 6.068 h 3.254 z m -11.515,-165.956 c -6.87,0 -12.442,-5.571 -12.442,-12.442 0,-6.87 5.572,-12.443 12.442,-12.443 6.871,0 12.443,5.573 12.443,12.443 0,6.871 -5.572,12.442 -12.443,12.442 m -81.04,-21.057 h -7.504 v -10.809 h 7.504 z m -24.131,194.43 h 8.553 v 7.893 c -3.712,-1.94 -7.214,-4.608 -8.553,-7.893 m 12.617,-3.091 h 5.671 v 20.398 h -5.671 z m 36.643,16.321 h 28.922 v 7.91 H -73.065 Z M 0.626,28.533 c 0,-3.431 2.782,-6.212 6.213,-6.212 3.432,0 6.214,2.781 6.214,6.212 0,3.432 -2.782,6.214 -6.214,6.214 -3.431,0 -6.213,-2.782 -6.213,-6.214 M 0.545,6.068 h 16.28 V -21.206 H -1.902 l -10.272,-114.516 c 10.527,-2.283 18.415,-11.654 18.415,-22.863 0,-12.92 -10.476,-23.395 -23.395,-23.395 -8.688,0 -16.273,4.74 -20.308,11.774 h -57.351 v -11.397 h -14.728 v 11.484 c -1.611,0.346 -2.852,1.705 -2.997,3.413 l -15.777,186.519 h -11.028 v 7.419 H -130 c 1.528,7.496 8.934,12.935 16.228,16.062 v 5.399 h 13.849 v -1.457 c 7.297,1.567 14.644,2.68 22.132,3.027 v 2.438 h 38.329 v -3.355 c 7.219,-0.256 14.563,-1.312 21.253,-3.71 6.171,-2.214 11.743,-5.553 16.12,-10.421 1.969,2.692 5.149,4.439 8.738,4.439 5.974,0 10.82,-4.844 10.82,-10.819 0,-5.974 -4.846,-10.819 -10.82,-10.819 -1.774,0 -3.449,0.428 -4.927,1.184 z m -35.13,-32.671 h -39.533 v -6.018 h 39.533 z m 4.989,-10.827 h -49.553 v 15.58 h 49.553 z m 12.442,-113.149 c 4.421,0 8.007,-3.585 8.007,-8.006 0,-4.421 -3.586,-8.006 -8.007,-8.006 -4.421,0 -8.006,3.585 -8.006,8.006 0,4.421 3.585,8.006 8.006,8.006"
              style="fill:#050607;fill-opacity:1;fill-rule:nonzero;stroke:none"
              transform="matrix(1.3333333,0,0,-1.3333333,482.15093,398.15)"
              clip-path="url(#clipPath3)"/>
            <path
              id="path4"
              d="M 0,0 -145.123,-147.265 -283.464,-1.879 v -10.734 l 133.145,-139.924 -129.677,-131.591 5.361,-5.099 129.419,131.327 123.998,-130.312 5.362,5.1 L -140.02,-152.627 0,-10.54 Z"
              style="fill:#050607;fill-opacity:1;fill-rule:nonzero;stroke:none"
              transform="matrix(1.3333333,0,0,-1.3333333,585.8296,292.2296)"
              clip-path="url(#clipPath5)"/>
          </g>
        </svg>
      </span>
    )
  }

  renderCloseIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
          <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
        </svg>
      </span>
    );
  }

  renderArrowLeftIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"/>
        </svg>
      </span>
    );
  }

  renderArrowRightIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"/>
        </svg>
      </span>
    );
  }

  renderArrowTopIcon() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.solid}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"/>
        </svg>
      </span>
    );
  }

  renderExclamationPoint() {
    return (
      <span aria-hidden="true" class={`${styles.icon} ${styles.exclamation}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"/>
      </svg>
      </span>
    );
  }

  renderShareIcon() {
    return (
      <span aria-hidden="true" className={`${styles.icon} ${styles.solid}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M296 160c13.3 0 24-10.7 24-24l0-8 0-16 0-48L480 208 320 352l0-48 0-16 0-8c0-13.3-10.7-24-24-24l-8 0-96 0c-70.7 0-128 57.3-128 128c0 8.3 .7 16.1 2 23.2C47.9 383.7 32 350.1 32 304c0-79.5 64.5-144 144-144l112 0 8 0zm-8 144l0 16 0 32c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2l0 32 0 16 0 16-32 0-80 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l64 0 32 0 0 16z"/></svg>
      </span>
    );
  }

  renderCheckmarkIcon() {
    return (
      <span aria-hidden="true" className={`${styles.icon} ${styles.check}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
        </svg>
      </span>
    );
  }

  renderExclamationMarkIcon() {
    return (
      <span aria-hidden="true" className={`${styles.icon} ${styles.warning}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
        </svg>
      </span>
    );
  }
}

export let icons = new Icons();
